module.exports = __webpack_public_path__ + "img/App book Numeracy.en.200d2f07.png";